define('constants/scheduledReportGraphByConstants',[], function() {
    return {
        Unknown: "0",
        Hour: "1",
        Day: "2",
        Week: "3",
        Month: "4"
    };
});
